<div *ngIf="processing" class="disclaimer">{{ 'analizando' | translate}}</div>
<div *ngIf="waiting" class="disclaimer">{{ 'iniciar_analisis' | translate}}</div>
<div *ngIf="waiting" class="waiting">{{ 'sistema_conectara' | translate}}</div>
<div *ngIf="waiting || processing" class="waiting">{{ 'esta_operacion_minutos' | translate}}</div>
<div class="buttons">
  <button *ngIf="waiting" class="cancel" (click)="close()">{{ 'cancelar' | translate}}</button>
  <button *ngIf="waiting" class="submit" (click)="analyze()">{{ 'analizar' | translate}}</button>
</div>
